import React from 'react';
import { Typography, TypographyProps } from '@material-ui/core';

const StyledDocumentSubtitle: React.FC<TypographyProps> = props => (
  <Typography variant="body1" style={{ fontWeight: 600 }} {...props} />
);

export default StyledDocumentSubtitle;
